import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import Request, { API_URL } from "../../../../request";
import {
  Button,
  Card,
  Form,
  Popconfirm,
  notification,
  Tabs,
  Upload,
  Icon,
  Row,
  Col,
  List,
  Select,
  Input,
  Radio,
  Tooltip,
} from "antd";
import { FaArrowRight } from "react-icons/fa";
import _ from "lodash";
import { hideLoader, showLoader } from "../../../../modules/actions";
import { connect } from "react-redux";
// import styles from './styles.less'
import { RightsWrapper } from "../../../../components/_utils/utils";

const Option = Select.Option;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;

// following variables needed for update country
let docLoaded = null;
let countryId = null;
@Form.create()
class ProcessCountry extends PureComponent {
  state = {
    activeTab: "0",
    id: "",
    countryId: "",
    deskProcessArray: [],
  };

  callback = (value) => {
    if (value) {
      this.chooseTab(value);
    }
  };
  deleteProcessDetails(processId) {
    if (processId) {
      processId.countryId = this.state.countryId;
      Request.deleteProcessDetail(processId).then((res) => {
        if (!res.error) {
          this.table.current.reload();
          notification.success({
            message: res.message,
          });
        } else {
          notification.error({
            message: res.message,
          });
        }
      });
    }
  }
  setCountryProcessDetails(processId) {
    if (processId) {
      let data = {
        id: processId,
        countryId: this.state.countryId,
      };
      Request.getProcessDetailsById(data).then(({ doc, error, message }) => {
        if (!error && doc) {
          this.setState({
            id: doc.processedDocuments._id,
            activeTab: "1",
          });
          this.props.form.setFieldsValue({
            documentTitle: doc.processedDocuments.documentTitle,
            desk: doc.processedDocuments.desk,
          });
        }
      });
    }
  }
  chooseTab(value) {
    this.setState({
      activeTab: value,
    });
  }
  constructor(props) {
    super(props);
    this.table = React.createRef();
  }

  handleSubmit = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let response;
        let values = _.clone(valData);
        values.countryId = this.state.countryId;
        if (this.state.id) {
          values._id = this.state.id;
          response = await Request.updateCountryProcessed(values);
        } else {
          response = await Request.addCountryProcessed(values);
        }

        if (!response.error) {
          this.setState({ activeTab: "0" });
          form.resetFields();
          notification.success({
            message: response.message,
          });
          if (this.table && this.table.current) this.table.current.reload();
        } else {
          notification.error({
            message: response.message,
          });
        }
      }
    });
  };

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      resolve([]);
    });
  };
  resetFormValues() {
    let searchParams = new URLSearchParams(this.props.search);
    countryId = searchParams.get("id");
    if (countryId) {
      this.setState({ countryId: countryId });
    }
  }

  componentDidMount() {
    this.resetFormValues();
  }

  addStatus = (desk) => {
    let processStatusName = prompt("Enter Process Status Name:");

    if (!processStatusName) return;

    const statusSlugName = processStatusName.replace(/\s+/g, "_");
    this.setState((prevState) => {
        const deskProcessArray = { ...prevState.deskProcessArray };
    
        if (!deskProcessArray[desk]) {
          deskProcessArray[desk] = [];
        }
    
        deskProcessArray[desk] = [
          ...deskProcessArray[desk],
          { statusKey: statusSlugName, statusValue: processStatusName, fields: [] },
        ];
    
        return { deskProcessArray };
      });
  };
  addFields = (deskKey, statusKey) => {
    const fieldName = prompt("Enter field name:");

    if (!fieldName) return;

    console.log(deskKey)

    console.log(statusKey)

    const fieldKey = fieldName.replace(/\s+/g, "_");

    console.log(fieldName)
    console.log(fieldKey)
    this.setState((prevState) => {
        const deskProcessArray = { ...prevState.deskProcessArray };
        if(deskProcessArray[deskKey] !== undefined) {
            deskProcessArray[deskKey].forEach(deskProcess => {
                if(deskProcess.statusKey === statusKey) {
                    deskProcess.fields.push({
                        fieldKey: fieldKey,
                        fieldName: fieldName,
                        fieldType: '',
                        fieldDefaultValue: '',
                        fieldOptions: []
                    })
                }
            });
        }
        console.log(deskProcessArray[deskKey])
        return { deskProcessArray };
    });
  };
  render() {
    const {
      form: { getFieldDecorator, setFieldsValue },
    } = this.props;
    const { deskProcessArray } = this.state;
    
    let desksList = [
      {
        key: "operation_manager_desk",
        text: "Operation Manager Desk",
      },
      {
        key: "counselling_desk",
        text: "Counselling Desk",
      },
      {
        key: "registration_desk",
        text: "Registration Desk",
      },
      {
        key: "application_desk",
        text: "Application Desk",
      },
      {
        key: "visa_support_desk",
        text: "Visa Support Desk",
      },
      {
        key: "visa_filling_desk",
        text: "Visa Filling Desk",
      },
      {
        key: "claim_desk",
        text: "Claim Desk",
      }
    ];
    return (
      <PageHeaderWrapper title="Process Country">
        {desksList.map((desk, index) => (
          <Card
            key={index}
            style={{ minHeight: "184px", marginBottom: "25px" }}
            bodyStyle={{ padding: "4px" }}
            title={<span style={{ paddingLeft: "10px" }}>{desk.text}</span>}
            extra={
              <Button
                onClick={() => this.addStatus(desk.key)}
                style={{ color: "#fff", background: "#ed1c24" }}
              >
                Add Status
              </Button>
            }
          >
            {deskProcessArray[desk.key] &&
            deskProcessArray[desk.key].length > 0 ? (
              deskProcessArray[desk.key].map((status, idx) => (
                <Card 
                    key={idx}
                    title={<span style={{ paddingLeft: "10px" }}>{status.statusValue}({status.statusKey})</span>}
                    style={{ marginTop: "10px" }}
                    extra={
                        <Button
                          onClick={this.addFields(desk.key, status.statusKey)}
                          style={{ color: "#fff", background: "#ed1c24" }}
                        >
                          Add Fields
                        </Button>
                    }>
                    <Row>
                        <Col span={8}>
                            <span></span>
                        </Col>
                        <Col span={8}>
                            <span>{status.statusKey}</span>
                        </Col>
                        <Col span={8}>
                            <Button
                                style={{ color: "#fff", background: "#0eb8f7" }}
                                onClick={() =>
                                    {this.addFields(desk.key, status.statusKey)}
                                }>
                                Add Fields
                            </Button>
                        </Col>
                    </Row>
                    {status.fields &&
                        status.fields.length > 0 ? (
                            status.fields.map((field, indx) => (
                                <Row key={indx} style={{ marginTop: "10px" }}>
                                    <Col span={8}>
                                        <FaArrowRight />
                                    </Col>
                                    <Col span={8}>
                                        <span>{field.fieldName}</span>
                                    </Col>
                                    <Col span={8}>
                                        <span>{field.fieldKey}</span>
                                    </Col>
                                </Row>
                            ))
                        ):null
                    }
                </Card>
              ))
            ) : (
              <p>No process added yet!!!</p>
            )}
          </Card>
        ))}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProcessCountry);
